<template>
    <div class="dashboard-proposal" style="margin-top: 60px">
        <load-screen-component></load-screen-component>
        <div class="dashboard-proposal__toolbar">
            <div class="dashboard-proposal__identity">
                <span class="dashboard-proposal__icon"><i class="icon-layers2"></i></span>
                <div>
                    <span class="dashboard-proposal__eyebrow">Dashboard</span>
                    <strong class="dashboard-proposal__name">Propostas</strong>
                </div>
            </div>
            <div class="toolbar-select dashboard-proposal__filter">
                            <span class="toolbar-select-label">
                                <i class="icon-grid"></i>
                                {{ t('NAV.ALLOTMENT_S') }}:
                            </span>
                <div class="toolbar-select-control">
                    <Select2
                            class="align-self-center"
                            v-model="allotmentId" :options="allotments" @select="changeAllotment($event)"
                            :settings="{width:'100%'}" placeholder="Selecione"
                    ></Select2>
                </div>
            </div>
        </div>
        <div class="card dashboard-proposal__main">
            <div class="dashboard-proposal__section-header">
                <h4 class="dashboard-section-title"><i class="icon-layers2"></i>Propostas</h4>
                <span class="dashboard-proposal__total">Total: {{ totalProposal }}</span>
            </div>
            <div class="row gutters">
                <div class="col-lg-6 col-12 d-flex flex-wrap">
                    <div class="d-flex flex-column p-3 flex-grow-1 col-12 proposal-dashboard-moment-card">
                        <h5 class="font-weight-bold">
                            {{ t('DASHBOARD_PROPOSAL.NOW_MOMENT') }}
                        </h5>
                        <div class="row gutters mt-4 p-2 pt-5">
                            <div class="col-6 pointer">
                                <h2 class="font-weight-bold pl-1"> {{ allByStatus['EM AVALIAÇÃO'] }} </h2>
                                <h6 class="mt-1"><i
                                        class="icon-schedule"></i> {{ t("DASHBOARD_PROPOSAL.IN_AVALIATION") }}</h6>
                            </div>
                            <div class="col-6 pointer">
                                <h2 class="font-weight-bold pl-1">{{ allByStatus['PENDENTE'] }}</h2>
                                <h6 class="mt-1"><i
                                        class="icon-warning1"></i> {{ t("DASHBOARD_PROPOSAL.PENDING") }}</h6>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-12 d-flex flex-wrap">
                    <div class="d-flex flex-column p-3 flex-grow-1 col-12 proposal-dashboard-status-card">
                        <h5 class="font-weight-bold">
                            {{ t('DASHBOARD_PROPOSAL.QTD_BY_STATUS') }}
                        </h5>
                        <div id="graficQtdProposalStatus"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card dashboard-proposal__progress">
            <div class="dashboard-proposal__section-header">
                <h4 class="dashboard-section-title">
                    <i class="icon-schedule"></i>{{ this.t('DASHBOARD_PROPOSAL.PROGRESS_ADD_PROPOSAL') }}</h4>
                <div class="dashboard-segmented">
                    <button type="button"
                            :class="grapicDay ?'' :'active'"
                            @click="mountGraficProgressByAdd();grapicDay = false">
                        <i v-if="!grapicDay"
                           class="icon-check-circle">
                        </i>
                        {{ t('DASHBOARD_PROPOSAL.LAST_12_MONTHS') }}
                    </button>
                    <button type="button"
                            @click="mountGraficProgressByAdd(true);grapicDay = true"
                            :class="grapicDay ?'active' :''">
                        <i v-if="grapicDay"
                           class="icon-check-circle">
                        </i>
                        {{ t('DASHBOARD_PROPOSAL.LAST_30_DAYS') }}
                    </button>
                </div>
            </div>
            <div class="main-container" :class="loadChartStatus ? 'filterBlur' : ''"
                 style="height: 40vh">
                <div id="chartProgressAdd"></div>
            </div>
        </div>
    </div>
</template>

<script>
import {useToast} from 'vue-toastification';
import {useI18n} from 'vue-i18n';
import loadScreenComponent from '../../components/layouts/loadScreenComponent';
import * as ApexCharts from "apexcharts";
import Dashboard from '../../services/Dashboard';
import StatusProposal from '../../mixins/StatusProposal';
import Select2 from 'vue3-select2-component';
import {mapState} from 'vuex';
import UserCompanies from '../../services/UserCompanies';

export default {
    name: "dashboardComponent",
    components: {
        loadScreenComponent,
        Select2,
    },
    beforeRouteLeave(to, from, next) {
        this.chartGraphicStatus?.destroy();
        this.chartQtsByStatus?.destroy();
        return next();
    },
    unmounted() {
        this.chartGraphicStatus?.destroy();
        this.chartQtsByStatus?.destroy();
    },
    mixins: [StatusProposal],
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    data() {
        return {
            allotmentId: null,
            loadChartStatus: false,
            chartGraphicStatus: null,
            chartQtsByStatus: null,
            totalProposal: 0,
            allByStatus: {},
        }
    },
    computed: {
        ...mapState({
            allotments: 'allotments',
        })
    },
    mounted() {
        if (!sessionStorage.getItem('allotmentIdScope')) {
            this.$router.push({name: 'IndexProposal'})
        }
        this.allotmentId = sessionStorage.getItem('allotmentIdScope');
        this.mountGraficProposalByStatus();
        this.mountGraficProgressByAdd();
    },
    methods: {
        async changeAllotment({id}) {
            sessionStorage.removeItem('allotmentIdScope');
            sessionStorage.setItem('allotmentIdScope', id);
            await this.chanceCustomScope(id);
            this.$router.go();
        },
        async chanceCustomScope(id) {
            await UserCompanies.chanceCustomScope(id).then(resp => {
                this.$setCustomToken(resp.data.accessToken, resp.data.refreshToken);
            }).catch(err => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(err);
            });
        },
        mountGraficProgressByAdd(days = null) {
            this.loadChartStatus = true
            Dashboard.getProgressProposalAdd(this.allotmentId, days).then(resp => {
                let seriesStatus = [];
                let colors = [];
                let categories = resp.data.categories;
                delete resp.data.categories;
                Object.keys(resp.data).forEach(k => {
                    seriesStatus.push({
                        name: this.translateStatus(k),
                        data: resp.data[k],
                    })
                    colors.push(this.translateColorStatus(k));
                })
                let chartOptionsStatus = {
                    chart: {
                        height: '100%',
                        type: 'area',
                        width: '100%',
                        defaultLocale: 'pt',
                        locales: [{
                            name: 'pt',
                            options: {
                                toolbar: {
                                    download: 'Download SVG',
                                    selection: 'Selecionar',
                                    selectionZoom: 'Selecionar Zoom',
                                    zoomIn: 'Aumentar Zoom',
                                    zoomOut: 'Reduzir Zoom',
                                    pan: 'Panorama',
                                    reset: 'Resetar Zoom',
                                }
                            }
                        }]
                    },
                    responsive: [
                        {
                            breakpoint: 1000,
                            options: {
                                legend: {
                                    position: "bottom"
                                }
                            }
                        }
                    ],
                    legend: {
                        position: 'top',
                        horizontalAlign: 'center',
                    },
                    noData: {
                        text: 'Nenhum dado para ser carregado',
                        align: 'center',
                        verticalAlign: 'middle',
                    },
                    series: seriesStatus,
                    xaxis: {
                        convertedCatToNumeric: false,
                        categories: categories
                    },
                    colors: colors,
                };
                let elChartAssign = document.getElementById('chartProgressAdd');
                this.chartGraphicStatus?.destroy();
                this.chartGraphicStatus = new ApexCharts(elChartAssign, chartOptionsStatus);
                this.chartGraphicStatus.render();
                this.loadChartStatus = false
            })
        },
        mountGraficProposalByStatus() {
            Dashboard.getQtdProposalByStatus(this.allotmentId).then((resp) => {
                this.allByStatus = resp.data;
                this.totalProposal = 0;
                let data = [];
                let categoryx = [];
                let colors = [];
                Object.keys(resp.data).forEach(s => {
                    this.totalProposal += resp.data[s];
                    switch (s) {
                        case 'APROVADA':
                            data.push(resp.data[s]);
                            categoryx.push('Aprovadas');
                            colors.push(this.translateColorStatus('APROVADA'));
                            break;
                        case 'REJEITADA':
                            data.push(resp.data[s]);
                            categoryx.push('Rejeitadas');
                            colors.push(this.translateColorStatus('REJEITADA'));
                            break;
                        case 'VENDA CANCELADA':
                            data.push(resp.data[s]);
                            categoryx.push(['Venda', 'Cancelada']);
                            colors.push(this.translateColorStatus('VENDA CANCELADA'));
                            break;
                        case 'EXPIRADA':
                            data.push(resp.data[s]);
                            categoryx.push('Expiradas');
                            colors.push(this.translateColorStatus('EXPIRADA'));
                            break;
                        case 'CANCELADA':
                            data.push(resp.data[s]);
                            categoryx.push('Canceladas');
                            colors.push(this.translateColorStatus('CANCELADA'));
                            break;
                    }
                });
                var options = {
                    series: [{
                        data: data
                    }],
                    chart: {
                        height: '100%',
                        type: 'bar',
                    },
                    colors: colors,
                    plotOptions: {
                        bar: {
                            columnWidth: '45%',
                            borderRadius: 6,
                            borderRadiusApplication: 'end',
                            distributed: true,
                            dataLabels: {
                                position: 'top',
                            }
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        offsetY: -20,
                        formatter: function (_, {dataPointIndex}) {
                            return data[dataPointIndex];
                        },
                        style: {
                            fontSize: '12px',
                            colors: ['#000']
                        }
                    },
                    legend: {
                        show: false
                    },
                    xaxis: {
                        categories: categoryx,
                        labels: {
                            style: {
                                fontSize: '12px'
                            }
                        }
                    },
                    yaxis: {
                        min: 0,
                        max: function (max) {
                            return Math.max(max + 1, 1);
                        },
                        forceNiceScale: true,
                        decimalsInFloat: 0,
                        labels: {
                            formatter: function (value) {
                                return parseInt(value);
                            }
                        }
                    }
                };
                this.chartQtsByStatus?.destroy();
                this.chartQtsByStatus = new ApexCharts(document.querySelector("#graficQtdProposalStatus"), options);
                this.chartQtsByStatus.render();
            })
        }
    }
}
</script>

<style scoped>
.filterBlur {
    filter: blur(5px)
}

.dashboard-proposal__toolbar {
    align-items: center;
    background:
        radial-gradient(ellipse at 0% 0%, rgba(14, 94, 78, 0.10), transparent 55%),
        linear-gradient(135deg, #edf8f5 0%, #ffffff 100%);
    border: 1px solid #cfe5df;
    border-radius: 16px;
    box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.85),
        0 14px 32px rgba(15, 23, 42, 0.07);
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: space-between;
    margin-bottom: 0.75rem;
    padding: 1rem 1.1rem;
}

.dashboard-proposal__identity {
    align-items: center;
    display: flex;
    gap: 0.85rem;
    min-width: 0;
}

.dashboard-proposal__icon {
    align-items: center;
    background: #0e5e4e;
    border-radius: 14px;
    box-shadow: 0 10px 22px rgba(14, 94, 78, 0.25);
    color: #ffffff;
    display: inline-flex;
    flex: 0 0 46px;
    font-size: 1.25rem;
    height: 46px;
    justify-content: center;
    width: 46px;
}

.dashboard-proposal__eyebrow {
    color: #0e5e4e;
    display: block;
    font-size: 0.68rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.dashboard-proposal__name {
    color: #173b34;
    display: block;
    font-size: 1.15rem;
    font-weight: 800;
    line-height: 1.25;
}

.dashboard-proposal__filter {
    margin: 0;
    min-width: 260px;
}

.dashboard-proposal__main,
.dashboard-proposal__progress {
    border-radius: 14px;
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
    margin-bottom: 0.75rem;
    padding: 1rem 1rem 0.75rem;
}

.dashboard-proposal__section-header {
    align-items: center;
    border-bottom: 1px solid rgba(14, 94, 78, 0.12);
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    justify-content: space-between;
    margin-bottom: 0.85rem;
    padding-bottom: 0.6rem;
}

.dashboard-proposal__section-header > :first-child {
    flex: 1 1 auto;
}

.dashboard-section-title {
    align-items: center;
    border-left: 4px solid #0e5e4e;
    color: #173b34;
    display: flex;
    font-size: 1.02rem;
    font-weight: 800;
    gap: 0.5rem;
    margin: 0;
    padding-left: 0.65rem;
}

.dashboard-section-title i {
    color: #0e5e4e;
    font-size: 1.05rem;
}

.dashboard-proposal__total {
    background: #0e5e4e;
    border-radius: 999px;
    box-shadow: 0 8px 18px rgba(14, 94, 78, 0.20);
    color: #ffffff;
    font-size: 0.8rem;
    font-weight: 800;
    padding: 0.5rem 0.95rem;
    white-space: nowrap;
}

.dashboard-segmented {
    background: #e8f1ee;
    border-radius: 12px;
    display: inline-flex;
    gap: 4px;
    padding: 4px;
}

.dashboard-segmented button {
    align-items: center;
    background: transparent;
    border: 0;
    border-radius: 9px;
    color: #51616d;
    display: inline-flex;
    font-size: 0.8rem;
    font-weight: 800;
    gap: 0.35rem;
    min-height: 38px;
    padding: 0.5rem 1rem;
    transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
    white-space: nowrap;
}

.dashboard-segmented button:hover {
    color: #0e5e4e;
}

.dashboard-segmented button.active {
    background: #0e5e4e;
    box-shadow: 0 8px 18px rgba(14, 94, 78, 0.20);
    color: #ffffff;
}

html.dark-theme .dashboard-proposal__toolbar {
    background:
        radial-gradient(ellipse at 0% 0%, rgba(20, 184, 166, 0.18), transparent 55%),
        linear-gradient(135deg, rgba(17, 24, 39, 0.98) 0%, rgba(23, 32, 51, 0.96) 100%) !important;
    border-color: rgba(94, 234, 212, 0.18) !important;
}

html.dark-theme .dashboard-proposal__icon {
    background: #14b8a6 !important;
}

html.dark-theme .dashboard-proposal__eyebrow {
    color: #5eead4 !important;
}

html.dark-theme .dashboard-proposal__name {
    color: var(--dark-text) !important;
}

html.dark-theme .dashboard-proposal__main,
html.dark-theme .dashboard-proposal__progress {
    border-color: var(--dark-border) !important;
}

html.dark-theme .dashboard-proposal__section-header {
    border-bottom-color: rgba(94, 234, 212, 0.14) !important;
}

html.dark-theme .dashboard-section-title {
    border-left-color: #14b8a6 !important;
    color: var(--dark-text) !important;
}

html.dark-theme .dashboard-section-title i {
    color: #5eead4 !important;
}

html.dark-theme .dashboard-proposal__total {
    background: #14b8a6 !important;
}

html.dark-theme .dashboard-segmented {
    background: rgba(15, 23, 42, 0.42) !important;
}

html.dark-theme .dashboard-segmented button {
    color: var(--dark-text-muted) !important;
}

html.dark-theme .dashboard-segmented button:hover {
    color: #5eead4 !important;
}

html.dark-theme .dashboard-segmented button.active {
    background: #14b8a6 !important;
    color: #ffffff !important;
}

@media (max-width: 575px) {
    .dashboard-proposal__filter {
        min-width: 100%;
    }

    .dashboard-proposal__section-header {
        align-items: stretch;
        flex-direction: column;
    }

    .dashboard-proposal__total,
    .dashboard-segmented {
        align-self: flex-start;
    }
}
</style>
